import { render, staticRenderFns } from "./createDuplicateMou.vue?vue&type=template&id=3691adba&"
import script from "./createDuplicateMou.vue?vue&type=script&lang=js&"
export * from "./createDuplicateMou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports